export class AlterdataPHD {
    static isNavegadorDoPHD() {
        return navigator.userAgent.indexOf('Chrome/25.0.1364.') !== -1
    }
}



// WEBPACK FOOTER //
// ./src/app/core/util/alterdata-phd.ts